import type React from 'react'
import { cn, cva, type VariantProps } from '../lib/cva'
import { Text } from './Text'

const labelVariants = cva(
	'flex items-center justify-center px-3 h-6 text-neutral-800 rounded-full transition-colors focus:outline-none',
	{
		variants: {
			variant: {
				solid: '',
				outline: 'bg-transparent border',
			},
			color: {
				default: '',
				yellow: '',
				green: '',
				red: '',
			},
			disabled: {
				true: 'cursor-not-allowed pointer-events-none text-neutral-400',
				false: '',
			},
		},
		compoundVariants: [
			{
				variant: 'solid',
				color: 'default',
				className: 'bg-neutral-100',
			},
			{
				variant: 'solid',
				color: 'yellow',
				className: 'bg-warning-100',
			},
			{
				variant: 'solid',
				color: 'green',
				className: 'bg-success-100',
			},
			{
				variant: 'solid',
				color: 'red',
				className: 'bg-error-100',
			},
			{
				variant: 'outline',
				color: 'default',
				className: 'border-neutral-200',
			},
			{
				variant: 'outline',
				color: 'yellow',
				className: 'border-warning-200',
			},
			{
				variant: 'outline',
				color: 'green',
				className: 'border-success-200',
			},
			{
				variant: 'outline',
				color: 'red',
				className: 'border-error-200',
			},
		],
		defaultVariants: {
			variant: 'solid',
			color: 'default',
			disabled: false,
		},
	},
)

interface LabelProps extends VariantProps<typeof labelVariants> {
	children: React.ReactNode
	disabled?: boolean
	className?: string
}

export const Label: React.FC<LabelProps> = ({ variant, color, disabled = false, children, className, ...props }) => {
	return (
		<Text
			variant='hint'
			className={cn(labelVariants({ variant, color, disabled }), className)}
			aria-disabled={disabled}
			{...props}>
			{children}
		</Text>
	)
}
